import React from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import { block } from 'bem-cn';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import './Filters.scss';

const b = block('statistic-filters-desktop');

const Filters = ({ model }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  return (
    <form className={b()}>
      <span className={b('item-date-label')} />

      <div className={b('item-date-input')}>
        <div className={b('item-date-label')}>{locale.dateFrom}</div>
        <div className={b('input')}>
          <InputDate
            dateFormat="yyyy-MM-dd"
            selected={model.inputState.values.from}
            onChange={model.inputState.onChangeFrom}
          />
        </div>
      </div>
      <div className={b('item-date-input')}>
        <div className={b('item-date-label')}>{locale.dateTo}</div>
        <div className={b('input')}>
          <InputDate
            dateFormat="yyyy-MM-dd"
            selected={model.inputState.values.to}
            onChange={model.inputState.onChangeTo}
          />
        </div>
      </div>
      <div className={b('button')}>
        <Button callBack={model.outputState.onSubmit} text={locale.acceptFilter} />
      </div>

      {/* <div className={b('button')}>
        <Button type="submit">
          <span className={b('button-text')}>{locale2.acceptFilter}</span>
        </Button>
      </div> */}
    </form>
  );
};

export default Filters;
